import { useState, useEffect } from "react";
import { useAuth, apiFetch } from "../App";

function ReticleLogo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="30" stroke="#00e5b0" strokeWidth="3"/>
      <circle cx="32" cy="32" r="19" stroke="#00e5b0" strokeWidth="1.5" opacity="0.35"/>
      <circle cx="32" cy="32" r="6" fill="#00e5b0"/>
      <line x1="32" y1="2" x2="32" y2="12" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
      <line x1="32" y1="52" x2="32" y2="62" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
      <line x1="2" y1="32" x2="12" y2="32" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
      <line x1="52" y1="32" x2="62" y2="32" stroke="#00e5b0" strokeWidth="3" strokeLinecap="round"/>
      <line x1="11" y1="11" x2="17" y2="17" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
      <line x1="53" y1="11" x2="47" y2="17" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
      <line x1="11" y1="53" x2="17" y2="47" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
      <line x1="53" y1="53" x2="47" y2="47" stroke="#00e5b0" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
    </svg>
  );
}

export default function Login({ onBack, mode: initialMode = "login" }) {
  const { login } = useAuth();
  const [mode, setMode] = useState(initialMode);
  const [form, setForm] = useState({ name: "", email: "", password: "", dateOfBirth: "", startingBankroll: "1000" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotSuccess, setForgotSuccess] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [referralCode, setReferralCode] = useState('');

      useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const ref = params.get('ref');
    if (token) {
      setResetToken(token);
      setMode('reset');
    }
    if (ref) {
      setReferralCode(ref);
      setMode('register');
    }
  }, []);

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    setError("");
    if (!form.email || !form.password) return setError("Please fill in all required fields.");
    if (mode === "register" && !form.name) return setError("Please enter your name.");
if (mode === "register" && form.dateOfBirth) {
  const age = (Date.now() - new Date(form.dateOfBirth)) / (365.25 * 24 * 60 * 60 * 1000);
  if (age < 18) return setError("You must be 18 or older to register.");
}
setLoading(true);
try {
  const endpoint = mode === "login" ? "/auth/login" : "/auth/register";
  const body = mode === "login"
    ? { email: form.email, password: form.password }
    : { name: form.name, email: form.email, password: form.password, dateOfBirth: form.dateOfBirth || undefined, startingBankroll: parseFloat(form.startingBankroll) || 1000, referralCode: referralCode || undefined };
      const data = await apiFetch(endpoint, { method: "POST", body: JSON.stringify(body) });
      login(data.token, data.user);
    } catch (e) {
      setError(e.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

    async function submitForgot() {
    if (!forgotEmail) return setError("Please enter your email.");
    setLoading(true);
    setError("");
    try {
      await apiFetch('/auth/forgot-password', {
        method: "POST",
        body: JSON.stringify({ email: forgotEmail }),
      });
      setForgotSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

    async function submitReset() {
    if (!newPassword) return setError("Please enter a new password.");
    if (newPassword.length < 6) return setError("Password must be at least 6 characters.");
    setLoading(true);
    setError("");
    try {
      await apiFetch('/auth/reset-password', {
        method: "POST",
        body: JSON.stringify({ token: resetToken, password: newPassword }),
      });
      setResetSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = {
    width: "100%", padding: "12px 14px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 10, color: "#e8edf5",
    fontSize: 16, fontFamily: "'DM Sans', sans-serif",
    outline: "none", boxSizing: "border-box",
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#080d17",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px 16px",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        width: "100%",
        maxWidth: 420,
        background: "#0d1425",
        borderRadius: 20,
        padding: "32px 28px",
        border: "1px solid rgba(255,255,255,0.07)",
        boxShadow: "0 24px 80px rgba(0,0,0,0.5)",
      }}>

        {/* Back button */}
        {onBack && (
          <button onClick={onBack} style={{
            background: "none", border: "none", cursor: "pointer",
            color: "#5a6a82", fontSize: 13, padding: 0,
            marginBottom: 24, display: "flex", alignItems: "center", gap: 6,
          }}>
            ← Back to home
          </button>
        )}

        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
          <ReticleLogo size={40} />
          <div>
            <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 18, letterSpacing: 1, color: "#e8edf5" }}>
              ODDSEDGE<span style={{ color: "#3d8ef8" }}>BW</span>
            </div>
            <div style={{ fontSize: 11, color: "#5a6a82", letterSpacing: 2, textTransform: "uppercase" }}>
              Betting Intelligence
            </div>
          </div>
        </div>

        {/* Title */}
        <div style={{ marginBottom: 28 }}>
          <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 22, marginBottom: 6, color: "#e8edf5" }}>
            {mode === "login" ? "Welcome back" : "Create your account"}
          </h2>
          <p style={{ fontSize: 14, color: "#5a6a82" }}>
            {mode === "login" ? "Sign in to your OddsEdgeBW account" : "Start finding value across all 6 BW bookmakers"}
          </p>
        </div>

                {/* Forgot Password Mode */}
        {mode === "forgot" && (
          <div>
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🔑</div>
              <h2 style={{ color: "#edf2ff", fontSize: 20, margin: "0 0 8px" }}>Reset Password</h2>
              <p style={{ color: "#5a6a82", fontSize: 14, margin: 0 }}>Enter your email and we'll send you a reset link.</p>
            </div>
            {forgotSuccess ? (
              <div style={{ textAlign: "center", padding: "20px", background: "rgba(0,229,176,0.08)", borderRadius: 10 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
                <div style={{ color: "#00e5b0", fontWeight: 600, marginBottom: 8 }}>Email sent!</div>
                <div style={{ color: "#8fa3c8", fontSize: 13 }}>Check your inbox for a password reset link. It expires in 1 hour.</div>
              </div>
            ) : (
              <>
                {error && <div style={{ color: "#f04747", fontSize: 13, marginBottom: 12, textAlign: "center" }}>{error}</div>}
                <input
                  type="email"
                  placeholder="Your email address"
                  value={forgotEmail}
                  onChange={e => setForgotEmail(e.target.value)}
                  style={{ ...inputStyle, marginBottom: 16 }}
                />
                <button
                  onClick={submitForgot}
                  disabled={loading}
                  style={{ width: "100%", padding: "14px", background: "#00e5b0", border: "none", borderRadius: 10, color: "#080d17", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", marginBottom: 16 }}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              </>
            )}
            <div style={{ textAlign: "center" }}>
              <button onClick={() => { setMode("login"); setError(""); setForgotSuccess(false); }} style={{ color: "#4d6080", background: "none", border: "none", cursor: "pointer", fontSize: 13 }}>
                ← Back to login
              </button>
            </div>
          </div>
        )}

        {/* Reset Password Mode */}
        {mode === "reset" && (
          <div>
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🔐</div>
              <h2 style={{ color: "#edf2ff", fontSize: 20, margin: "0 0 8px" }}>Choose New Password</h2>
              <p style={{ color: "#5a6a82", fontSize: 14, margin: 0 }}>Enter your new password below.</p>
            </div>
            {resetSuccess ? (
              <div style={{ textAlign: "center", padding: "20px", background: "rgba(0,229,176,0.08)", borderRadius: 10 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
                <div style={{ color: "#00e5b0", fontWeight: 600, marginBottom: 8 }}>Password reset!</div>
                <div style={{ color: "#8fa3c8", fontSize: 13, marginBottom: 16 }}>Your password has been updated successfully.</div>
                <button
                  onClick={() => { setMode("login"); setError(""); setResetSuccess(false); window.history.replaceState({}, '', '/'); }}
                  style={{ background: "#00e5b0", color: "#080d17", border: "none", borderRadius: 8, padding: "10px 24px", fontWeight: 700, cursor: "pointer" }}
                >
                  Sign in now
                </button>
              </div>
            ) : (
              <>
                {error && <div style={{ color: "#f04747", fontSize: 13, marginBottom: 12, textAlign: "center" }}>{error}</div>}
                <input
                  type="password"
                  placeholder="New password (min 6 characters)"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  style={{ ...inputStyle, marginBottom: 16 }}
                />
                <button
                  onClick={submitReset}
                  disabled={loading}
                  style={{ width: "100%", padding: "14px", background: "#00e5b0", border: "none", borderRadius: 10, color: "#080d17", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}
                >
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
              </>
            )}
          </div>
        )}

        {/* Form */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 20 }}>

        {/* Form */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 20 }}>
          {mode === "register" && (
            <div>
              <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Full Name</label>
              <input
                style={inputStyle}
                placeholder="John Smith"
                value={form.name}
                onChange={e => update("name", e.target.value)}
                autoComplete="name"
              />
            </div>
          )}

          <div>
            <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Email</label>
            <input
              style={inputStyle}
              type="email"
              placeholder="you@email.com"
              value={form.email}
              onChange={e => update("email", e.target.value)}
              autoComplete="email"
              onKeyDown={e => e.key === "Enter" && submit()}
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Password</label>
            <input
              style={inputStyle}
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => update("password", e.target.value)}
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              onKeyDown={e => e.key === "Enter" && submit()}
            />
          </div>

{mode === "register" && (
  <div>
    <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Date of Birth</label>
    <input
      style={inputStyle}
      type="date"
      value={form.dateOfBirth}
      onChange={e => update("dateOfBirth", e.target.value)}
      max={new Date(Date.now() - 18 * 365.25 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
    />
    <div style={{ fontSize: 11, color: "#5a6a82", marginTop: 6 }}>
      You must be 18 or older to use OddsEdgeBW.
    </div>
  </div>
)}

          {mode === "register" && (
            <div>
              <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Starting Bankroll (BWP)</label>
              <input
                style={inputStyle}
                type="number"
                placeholder="1000"
                value={form.startingBankroll}
                onChange={e => update("startingBankroll", e.target.value)}
              />
              <div style={{ fontSize: 11, color: "#5a6a82", marginTop: 6 }}>
                This sets up your bankroll tracker. You can change it anytime.
              </div>
            </div>
          )}
        </div>

            {mode === "register" && referralCode && (
            <div>
              <label style={{ display: "block", fontSize: 12, color: "#a8b4c8", marginBottom: 6, fontFamily: "'Syne', sans-serif", textTransform: "uppercase", letterSpacing: 0.5 }}>Referral Code</label>
              <input
                style={{ ...inputStyle, background: "rgba(0,229,176,0.06)", border: "1px solid rgba(0,229,176,0.2)" }}
                placeholder="Referral code"
                value={referralCode}
                onChange={e => setReferralCode(e.target.value)}
              />
              <div style={{ fontSize: 11, color: "#00e5b0", marginTop: 6 }}>
                ✓ Referral code applied
              </div>
            </div>
          )}

        {/* Error */}
        {error && (
          <div style={{
            padding: "10px 14px", borderRadius: 8,
            background: "rgba(240,71,71,0.1)", border: "1px solid rgba(240,71,71,0.2)",
            color: "#f04747", fontSize: 13, marginBottom: 16,
          }}>
            {error}
          </div>
        )}

        {/* Submit */}
        <button
          onClick={submit}
          disabled={loading}
          style={{
            width: "100%", padding: "14px",
            background: loading ? "rgba(0,229,176,0.5)" : "#00e5b0",
            border: "none", borderRadius: 10,
            color: "#080d17", fontWeight: 700, fontSize: 15,
            fontFamily: "'DM Sans', sans-serif",
            cursor: loading ? "not-allowed" : "pointer",
            marginBottom: 20,
          }}
        >
          {loading ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}
        </button>

        {/* Forgot password */}
        {mode === "login" && (
          <div style={{ textAlign: "center", marginBottom: 12 }}>
            <button
              onClick={() => setMode("forgot")}
              style={{ color: "#4d6080", background: "none", border: "none", cursor: "pointer", fontSize: 13 }}
            >
              Forgot your password?
            </button>
          </div>
        )}

        {/* Toggle */}
        <div style={{ textAlign: "center", fontSize: 14, color: "#5a6a82" }}>
          {mode === "login" ? (
            <>Don't have an account?{" "}
              <button onClick={() => { setMode("register"); setError(""); }} style={{ color: "#00e5b0", background: "none", border: "none", cursor: "pointer", fontWeight: 600, fontSize: 14 }}>
                Register
              </button>
            </>
          ) : (
            <>Already have an account?{" "}
              <button onClick={() => { setMode("login"); setError(""); }} style={{ color: "#00e5b0", background: "none", border: "none", cursor: "pointer", fontWeight: 600, fontSize: 14 }}>
                Sign in
              </button>
            </>
          )}
        </div>

        {/* Terms note */}
        {mode === "register" && (
          <div style={{ marginTop: 20, fontSize: 11, color: "#5a6a82", textAlign: "center", lineHeight: 1.6 }}>
            By registering you agree to our{" "}
            <a href="/terms.html" style={{ color: "#5a6a82", textDecoration: "underline" }}>Terms of Service</a>
            {" "}and{" "}
            <a href="/privacy.html" style={{ color: "#5a6a82", textDecoration: "underline" }}>Privacy Policy</a>.
            You must be 18+ to use OddsEdgeBW.
          </div>
          )}
        </div>
      </div>
    </div>
  );
}